var map = {
	"./angelist.png": 28147,
	"./crunchbase.png": 60794,
	"./f6s.png": 34843,
	"./fb.png": 69550,
	"./insta.png": 50333,
	"./linkedin.png": 33224,
	"./medium.png": 91279,
	"./tiktok.png": 61156,
	"./twitter.png": 80129,
	"./x.png": 29664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33200;